import amber from '@material-ui/core/colors/amber';
import green from '@material-ui/core/colors/green';
import IconButton from '@material-ui/core/IconButton';
import DefaultSnackBar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import { withStyles } from '@material-ui/core/styles';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CloseIcon from '@material-ui/icons/Close';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';
import WarningIcon from '@material-ui/icons/Warning';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { lazy } from 'react';
import { StoreSubscribe } from '../../../providers/global-store-provider';




const variantIcon = {
    success: CheckCircleIcon,
    warning: WarningIcon,
    error: ErrorIcon,
    info: InfoIcon,
};
/*
-----------------------------------------------------------------------
Theming
-----------------------------------------------------------------------
*/
const styles1 = theme => ({
    success: {
        backgroundColor: green[600],
    },
    error: {
        backgroundColor: theme.palette.error.dark,
    },
    info: {
        backgroundColor: theme.palette.primary.dark,
    },
    warning: {
        backgroundColor: amber[700],
    },
    icon: {
        fontSize: 20,
    },
    iconVariant: {
        opacity: 0.9,
        marginRight: theme.spacing(1),
    },
    message: {
        display: 'flex',
        alignItems: 'center',
    },
});
/*
-----------------------------------------------------------------------
RENDER Functions
-----------------------------------------------------------------------
*/
function CustomizedSnackbarContent(props) {
    const { classes, className, message, onClose, variant, ...other } = props;
    const Icon = variantIcon[variant];

    return (
        <SnackbarContent
            className={classNames(classes[variant], className)}
            aria-describedby="client-snackbar"
            message={
                <span id="client-snackbar" className={classes.message}>
                    <Icon className={classNames(classes.icon, classes.iconVariant)} />
                    {message}
                </span>
            }
            action={[
                <IconButton
                    key="close"
                    aria-label="Close"
                    color="inherit"
                    className={classes.close}
                    onClick={onClose}
                >
                    <CloseIcon className={classes.icon} />
                </IconButton>,
            ]}
            {...other}
        />
    );
}

CustomizedSnackbarContent.propTypes = {
    classes: PropTypes.object.isRequired,
    className: PropTypes.string,
    message: PropTypes.node,
    onClose: PropTypes.func,
    variant: PropTypes.oneOf(['success', 'warning', 'error', 'info']).isRequired,
};

const SnackbarContentWrapper = withStyles(styles1)(CustomizedSnackbarContent);
/*
-----------------------------------------------------------------------
Theming
-----------------------------------------------------------------------
*/
const styles2 = theme => ({
    margin: {
        margin: theme.spacing(1),
    },
    root: {

    }
});
class SnackBar extends React.Component {
    /*
    -----------------------------------------------------------------------
    RENDER Functions
    -----------------------------------------------------------------------
    */

    render() {
        return (
            <StoreSubscribe>
                {(store) =>
                    <DefaultSnackBar
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'center',
                        }}
                        open={store.state.snackbar.open}
                        onClose={this.handleClose}
                    >
                        <SnackbarContentWrapper
                            onClose={() => { store.snackbar.hideSnakBar() }}
                            variant={store.state.snackbar.type}
                            message={store.state.snackbar.message}
                        />
                    </DefaultSnackBar>
                }
            </StoreSubscribe>
        );
    }
}

SnackBar.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles2)(SnackBar);

